import { Box, Drawer } from "@mui/material";
import React from "react";

export const MainDrawerComponent = ({
  children,
  anchor,
  onOpen,
  onClose,
  isOpen = false,
}) => {
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    if (open && onOpen) {
      onOpen(open);
    } else if (onClose) {
      onClose(open);
    }
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
    >
      {children}
    </Box>
  );

  return (
    <Drawer anchor={anchor} open={isOpen} onClose={toggleDrawer(false)}>
      {list(anchor)}
    </Drawer>
  );
};
